<template>
  <div style="height: 300px;width: 100%;" />
</template>

<script>
import { apApFlowApi } from '@/api/ap/apApi'
import { debounce } from '@/utils/common'

export default {
  data() {
    return {
      simid: this.$route.query.simid,
      loading: false,

      daily: [],
      total_amount: null,
      total_used: null,

      chart: null,
      chartOption: {
        title: {
          text: '当月接入点流量统计',
        },
        grid: {
          left: '40%',
          right: 10,
          bottom: 10,
          // top: 10,
          containLabel: true
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          x: 0,
          y: 50,
          orient: 'vertical',
          data: ['已用流量', '剩余流量']
        },
        xAxis: {
          name: '日期',
          data: [],
          boundaryGap: true
        },
        yAxis: {
          type: 'value',
          name: '流量/M'
        },
        series: [
          {
            name: '使用统计',
            type: 'bar',
            barWidth: '61.8%',
            tooltip: {
              formatter: '{b}使用: {c}M'
            },
            data: []
          },
          {
            name: '分布占比',
            type: 'pie',
            center: ['20%', '55%'],
            radius: 100,
            right: 50,
            label: {
              show: true,
              position: 'inside',
              formatter: '{c}M'
            },
            tooltip: {
              formatter: '{b}: {c}M ({d}%)'
            },
            data: [
              {
                value: 0,
                name: '已用流量',
              },
              {
                value: 0,
                name: '剩余流量',
                itemStyle: {
                  color: 'rgba(128, 128, 128, .2)'
                }
              }
            ]
          }
        ]
      }
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.initChart()
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
  },
  methods: {
    fetchData() {
      this.loading = true
      apApFlowApi({ simid: this.simid }).then(res => {
        this.loading = false
        if (res.errno === 0) {
          this.daily = res.data.daily
          this.total_amount = res.data.total_amount
          this.total_used = res.data.total_used
          this.setChart()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    initChart() {
      this.chart = this.$echarts.init(this.$el, 'teenager')
      this.chart.setOption(this.chartOption)
    },
    setChart() {
      this.chartOption.xAxis.data = this.daily.map(v => v.date)
      this.chartOption.series[0].data = this.daily.map(v => v.used)

      var left = this.total_amount - this.total_used
      this.chartOption.series[1].data[0].value = this.total_used
      this.chartOption.series[1].data[1].value = left > 0 ? left : 0
      this.chart.setOption(this.chartOption)
    }
  }
}
</script>
